
export const getVoucher = () => {
    const URL = `https://tz00yhqoe2.execute-api.us-east-1.amazonaws.com/v1/voucher`;
    return URL  
  }

  export const redeemVoucher = () => {
    const URL = `https://tz00yhqoe2.execute-api.us-east-1.amazonaws.com/v1/deliveryInfo`;
    return URL  
  }

  export const getDeliveryInfos = () => {
    const URL = `https://tz00yhqoe2.execute-api.us-east-1.amazonaws.com/v1/deliveryInfos`;
    return URL  
  }

  export const getDeliveryInfosByDate = () => {
    const URL = `https://tz00yhqoe2.execute-api.us-east-1.amazonaws.com/v1/deliveryInfos`;
    return URL  
  } 

  export const updateDeliveryDetails = () => {
    const URL = `https://tz00yhqoe2.execute-api.us-east-1.amazonaws.com/v1/deliveryInfo/update`;
    return URL;
  }

  export const updateVoucher = () => {
    const URL = `https://tz00yhqoe2.execute-api.us-east-1.amazonaws.com/v1/voucherInfo/update`;
    return URL;
  }
  
  export const getAllVouchers = () => {
    const URL = 'https://tz00yhqoe2.execute-api.us-east-1.amazonaws.com/v1/vouchers';
    return URL;
  }
